export default __webpack_public_path__ + "static/media/cap.173a3c62.gif";